import type { HostPublicProfile } from '@/mocks/hostProfile';

interface Props {
  profile: HostPublicProfile;
}

export default function HostStatsSection({ profile }: Props) {
  const { stats } = profile;

  const kpis = [
    { label: 'Publicaciones', value: stats.totalPosts.toLocaleString(), icon: 'ri-article-line', change: '+12 este mes' },
    { label: 'Videos', value: stats.totalVideos.toLocaleString(), icon: 'ri-video-line', change: '+5 este mes' },
    { label: 'Eventos', value: stats.totalEvents.toLocaleString(), icon: 'ri-calendar-event-line', change: '+2 este mes' },
    { label: 'Interacciones', value: stats.totalInteractions.toLocaleString(), icon: 'ri-heart-pulse-line', change: null },
    { label: 'Alcance promedio', value: stats.avgReach.toLocaleString(), icon: 'ri-eye-line', change: 'por publicación' },
    { label: 'Crecimiento', value: `+${stats.followersGrowth}%`, icon: 'ri-line-chart-line', change: 'este mes' },
    { label: 'Engagement', value: `${stats.engagementRate}%`, icon: 'ri-bar-chart-2-line', change: 'tasa de interacción' },
    { label: 'Días activo', value: stats.daysActive.toLocaleString(), icon: 'ri-calendar-check-line', change: 'en la plataforma' },
  ];

  return (
    <section id="estadisticas" className="scroll-mt-24">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-bar-chart-grouped-line text-accent-500"></i>
          Estadísticas públicas
        </h2>
        <span className="text-[10px] text-foreground-400 bg-background-100 px-2 py-1 rounded-full">
          Datos actualizados
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {kpis.map((kpi) => (
          <div key={kpi.label} className="bg-white rounded-xl border border-foreground-100 p-4 hover:shadow-sm transition-all">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-7 h-7 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className={`${kpi.icon} text-accent-600 text-xs`}></i>
              </div>
              <span className="text-[10px] text-foreground-500 font-medium">{kpi.label}</span>
            </div>
            <span className="text-lg font-bold text-foreground-950 block">{kpi.value}</span>
            {kpi.change && (
              <span className="text-[10px] text-foreground-400 mt-0.5 block">{kpi.change}</span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}